import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useMessageReview } from "./ExpertMessageReviewHook";
// Set the default state values for each context
export const ExpertMessageReviewContext = /*#__PURE__*/createContext({});
export const ExpertMessageReviewContextProvider = ({
  children
}) => {
  const messageReviewState = useMessageReview();
  const {
    stateTracker
  } = useDevLogging();
  const reviewState = useMemo(() => {
    stateTracker.trackState({
      review: messageReviewState.messageReviewDetails
    });
    return {
      ...messageReviewState
    };
  }, [messageReviewState.messageReviewDetails, messageReviewState.message]);
  return /*#__PURE__*/React.createElement(ExpertMessageReviewContext.Provider, {
    value: reviewState
  }, children);
};
export const useExpertMessageReviewContext = () => {
  return useContext(ExpertMessageReviewContext);
};
ExpertMessageReviewContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};